import { contentfulClient } from "../../../services/contentful";

export const getAllContent = async () => contentfulClient.getEntries();
